module.exports = __webpack_public_path__ + "static/media/home_logo_v1.3.350d1f6a.png";